import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { createPinia } from "pinia";
import ApiService from "@/stores/base/api";
import naive from "naive-ui";

const pinia = createPinia();
const app = createApp(App);

// Base URL / branch key come from .env (see that file for why the branch
// key is not treated as a real secret). API Integrations v4 - migrated from
// v2 (see docs/v4-migration/DERAYAH-VUE-V4-FULL-MODERNIZATION-CERT-001.md).
ApiService.init(
  app,
  process.env.VUE_APP_API_BASE_URL as string,
  process.env.VUE_APP_INTEGRATION_BRANCH_KEY as string
);

app.use(pinia);
app.use(naive);
app.use(router);
app.mount("#app");
